import { ContextMenu, SVG } from "shared";
import { SVG_ENUM } from "enums";
import moment from "moment";
import { downloadFile } from "utils";

const isVideoFile = (name?: string) =>
  !!name && name.toLowerCase().endsWith(".mp4");

const isCompressing = (document: any) =>
  document?.compressionStatus === "compressing";

const items = ({
  setShowDelete,
  setPlayVideo,
}: {
  setShowDelete?: any;
  setPlayVideo?: (video: { url: string; name: string }) => void;
}) => {
  return (document: any) => {
    const actions = [];
    const compressing = isCompressing(document);
    if (document?.file?.url) {
      if (isVideoFile(document.file.name) || compressing) {
        actions.push({
          name: "Odtwórz",
          disabled: compressing,
          action: () =>
            setPlayVideo &&
            setPlayVideo({ url: document.file.url, name: document.file.name }),
          svg: SVG_ENUM.FILE,
        });
        actions.push({
          name: "Pobierz",
          disabled: compressing,
          action: () =>
            downloadFile({
              url: document.file.url,
              name: document.file.name,
            }),
          svg: SVG_ENUM.FILE,
        });
      } else {
        actions.push({
          name: "Pobierz",
          action: () =>
            downloadFile({
              url: document.file.url,
              name: document.file.name,
            }),
          svg: SVG_ENUM.FILE,
        });
      }
    }
    actions.push({
      name: "Usuń",
      action: () => setShowDelete && setShowDelete(document.uuid),
      svg: SVG_ENUM.TRASH,
    });

    return actions;
  };
};

const documentTypeMap: Record<string, string> = {
  testament: "Testament",
  notarial_documents: "Dokumenty notarialne",
  deed_of_ownership: "Akt własności",
  note: "Notatki prywatne",
};

export const mobileColumns = ({
  setShowDelete,
  setPlayVideo,
  canDelete = true,
}: {
  downloadFile?: any;
  setShowDelete?: any;
  setPlayVideo?: (video: { url: string; name: string }) => void;
  canDelete?: boolean;
}) => [
  {
    render: (value: any) => {
      const label = value.name || "Brak";
      return (
        <div>
          <p>{label}</p>
        </div>
      );
    },
  },
  {
    width: 20,
    render: (item: any) =>
      item?.compressionStatus === "compressing" ? (
        <span className="analyze-status analyze-status--inProgress">
          <p className="analyze-status__text">Kompresja</p>
          <SVG type={SVG_ENUM.ARROW_RELOAD} />
        </span>
      ) : canDelete ? (
        <ContextMenu
          data={item}
          items={items({
            setShowDelete,
            setPlayVideo,
          })(item)}
        >
          <SVG type={SVG_ENUM.DOTS} />
        </ContextMenu>
      ) : (
        <div
          className="context-menu__download"
          onClick={() =>
            isVideoFile(item?.file?.name)
              ? setPlayVideo &&
                setPlayVideo({ url: item.file.url, name: item.file.name })
              : downloadFile({ url: item.file.url, name: item.file.name })
          }
        >
          <SVG className="context-menu__icon" type={SVG_ENUM.FILE} />
        </div>
      ),
  },
];

export const desktopColumns = ({
  setShowDelete,
  setPlayVideo,
  canDelete = true,
}: {
  setShowDelete?: any;
  setPlayVideo?: (video: { url: string; name: string }) => void;
  canDelete?: boolean;
}) => {
  const columns = [
    {
      title: "Nazwa",
      width: "20%",
      render: (value: any) => value.name || "Brak",
    },
    {
      width: "20%",
      title: "Typ",
      key: "type",
      dataIndex: "type",
      render: (type: string) => documentTypeMap[type] || "none",
    },
    {
      width: "25%",
      title: "Data dodania",
      key: "createdAt",
      dataIndex: "createdAt",
      render: (date: string) => moment(date).format("DD.MM.YYYY"),
    },
    {
      width: "25%",
      title: "Opis",
      key: "description",
      dataIndex: "description",
    },
    {
      title: "Plik",
      width: 40,
      render: (item: any) => {
        if (!item?.file) return "Brak";
        return (
          <span
            className="clients-table__download"
            onClick={() =>
              isVideoFile(item.file.name)
                ? setPlayVideo &&
                  setPlayVideo({ url: item.file.url, name: item.file.name })
                : downloadFile({ name: item.file.name, url: item.file.url })
            }
          >
            <SVG type={SVG_ENUM.FILE} />
          </span>
        );
      },
    },
    {
      title: "",
      width: "140px",
      render: (item: any) =>
        item?.compressionStatus === "compressing" ? (
          <span className="analyze-status analyze-status--inProgress">
            <p className="analyze-status__text">Kompresja</p>
            <SVG type={SVG_ENUM.ARROW_RELOAD} />
          </span>
        ) : null,
    },
    {
      width: 20,
      render: (item: any) =>
        canDelete ? (
          <ContextMenu
            data={item}
            items={items({
              setShowDelete,
              setPlayVideo,
            })(item)}
          >
            <SVG type={SVG_ENUM.DOTS} />
          </ContextMenu>
        ) : (
          <div
            className="context-menu__download"
            onClick={() =>
              isVideoFile(item?.file?.name)
                ? setPlayVideo &&
                  setPlayVideo({ url: item.file.url, name: item.file.name })
                : downloadFile({ url: item.file.url, name: item.file.name })
            }
          >
            <SVG className="context-menu__icon" type={SVG_ENUM.FILE} />
          </div>
        ),
    },
  ];

  return columns;
};
